// extracted by mini-css-extract-plugin
module.exports = {"password":"style-module--password--2WNVo","changePass":"style-module--changePass--fUvtD","subscribe":"style-module--subscribe--2yzpS"};